import {FALLBACK_MATERIAL_TYPE} from '@aviary/store/common/common.fallback';
import {Hold} from '@store/holds/holds.types';

export const FALLBACK_HOLD: Hold = {
  id: 0,
  catalogRecordId: 0,
  catalogRecordIdentifier: '',
  patronFirstName: '',
  patronLastName: '',
  queueIdx: 0,
  status: 'HELD',
  expireDate: '',
  pickupExpireDate: '',
  notWantedBefore: '',
  notWantedAfter: '',
  type: '',
  materialType: FALLBACK_MATERIAL_TYPE,
  itemTitle: '',
  coverImageUrl: '',
  pickupBranchId: 0,
  pickupBranchName: '',
  pickupBranchAddress: '',
  pickupBranchPhone: '',
  circulatingCopies: 0,
  placedDate: '',
  modifiedDate: ''
};
